import { Alert, Box, Button, Divider, Stack, Typography } from "@mui/material";
import { DashboardData, Task } from "../../../services/swagger";
import { useState } from "react";
import TaskDialog from "../TaskDialog";
import { useTranslation } from "react-i18next";

export interface DashboardTasksProps {
  data: DashboardData;
}

export interface DashboardTaskProps {
  task: Task;
}

function DashboardTask(props: DashboardTaskProps) {
  const { t } = useTranslation("Dashboard");
  const { task } = props;
  const [open, setOpen] = useState(false);
  let severity: "info" | "error" | "success" | "warning" = "info";
  if (task.cancelDate) severity = "error";
  else if (task.endDate) severity = "success";
  else if (task.startDate) severity = "warning";
  return (
    <>
      <TaskDialog open={open} task={task} onClose={() => setOpen(false)} />
      <Alert
        severity={severity}
        action={
          <Button
            color="inherit"
            variant="outlined"
            size="small"
            onClick={() => setOpen(true)}
            sx={{ zIndex: 101 }}
          >
            {t("View")}
          </Button>
        }
      >
        {task.title}
      </Alert>
    </>
  );
}

export default function DashboardTasks(props: DashboardTasksProps) {
  const { t } = useTranslation("Dashboard");
  const { data } = props;

  return (
    <Stack spacing={2} mb={2} sx={{ p: { xs: 2, md: 0 } }}>
      <Box>
        <Divider />
      </Box>
      {data.activeTasks.length ? (
        data.activeTasks.map((e) => {
          return <DashboardTask key={e._id} task={e} />;
        })
      ) : (
        <Alert severity="info">{t("NoActiveTasks")}</Alert>
      )}
    </Stack>
  );
}
